module.exports = __webpack_public_path__ + "img/ic_chevron_filter.3fca97ae.svg";